import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

import Badge from '@repo/ui-components/tailwind/Badge';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

import { AttributesShape, VariantShape } from './PropShapes';

export default function CartItemDetails({ attributes, variant }) {
  const { tt } = useUiComponentsInternationalContext();

  const autoRenewal = attributes.find(at => at.key === 'Auto-renews');
  const options = variant.selectedOptions?.filter(
    opt => !['title'].includes(opt.name.toLowerCase())
  );

  const subDiscount =
    variant.product?.sellingPlanGroups?.nodes?.[0]?.sellingPlans?.nodes?.[0]
      ?.priceAdjustments?.[0]?.adjustmentValue?.adjustmentPercentage;

  return (
    <VStack align="flex-start" w="full">
      {autoRenewal && <Text>{autoRenewal.value}</Text>}
      {options.map(opt => (
        <Text key={opt.name}>
          {opt.name}: {opt.value}
        </Text>
      ))}
      {autoRenewal && variant.product?.sellingPlanGroups?.nodes?.length ? (
        <Badge
          message={tt(
            s => s.cartDeptComponents.subscriptionDiscountBadgeLabel,
            { discount: subDiscount }
          )}
          className="w-full px-1 text-center"
        />
      ) : null}
      {!autoRenewal && variant.product?.sellingPlanGroups?.nodes?.length ? (
        <Text
          cursor="pointer"
          color="primary.base"
          textDecor="underline"
          _hover={{ textDecor: 'none' }}
          fontWeight="bold"
        >
          {tt(s => s.cartDeptComponents.saveLabel, { discount: subDiscount })}
        </Text>
      ) : null}
    </VStack>
  );
}

CartItemDetails.propTypes = {
  attributes: AttributesShape.isRequired,
  variant: VariantShape.isRequired,
};
